export const RESET = 'SETTLEMENT_UPDATE_RESET'
export const SET_ERROR = 'SETTLEMENT_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'SETTLEMENT_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'SETTLEMENT_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'SETTLEMENT_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'SETTLEMENT_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'SETTLEMENT_UPDATE_UPDATE_RETRIEVED'
